// Vacation / absence calendar page
const en = {
  title: 'Vacation',
  subtitle: 'Shared calendar of vacations and absences -- who is away, and how many days everyone has left',
  addAbsence: '+ Add Absence',
  editAbsence: 'Edit Absence',
  newAbsence: 'New Absence',
  today: 'Today',
  prevMonth: 'Previous month',
  nextMonth: 'Next month',
  prevYear: 'Previous year',
  nextYear: 'Next year',
  viewMonth: 'Month',
  viewYear: 'Year',
  awayToday: 'Away today',
  nobodyAway: 'Everyone is in today',
  more: '+{{count}} more',
  type_vacation: 'Vacation',
  type_sick: 'Sick',
  type_other: 'Other',
  halfDay: 'Half day',
  person: 'Person',
  type: 'Type',
  from: 'From',
  to: 'To',
  note: 'Note',
  notePlaceholder: 'optional',
  workingDays: 'Working days (Mon–Fri): {{count}}',
  save: 'Save',
  saving: 'Saving...',
  delete: 'Delete',
  confirmDelete: 'Delete this entry?',
  failedToLoad: 'Failed to load calendar: {{error}}',
  failedToSave: 'Failed to save: {{error}}',
  readOnly: 'Only {{name}} or an admin can change this entry.',
  summaryTitle: 'Days in {{year}}',
  colName: 'Name',
  colAllowance: 'Allowance',
  colTaken: 'Taken',
  colPlanned: 'Planned',
  colRemaining: 'Remaining',
  colSick: 'Sick',
  colOther: 'Other',
  allowanceHint: 'Click to change the yearly allowance',
  countingNote: 'Days are counted Monday–Friday, without the public holidays entered in the calendar; half days count ½ each. Unused days carry over into the next year.',
  colCarryover: 'Carried over',
  carryoverHint: 'Unused days from earlier years (negative = overdrawn)',
  holidays: 'Holidays',
  holiday: 'Public holiday',
  holidaysTitle: 'Public holidays {{year}}',
  noHolidays: 'No public holidays entered for this year.',
  holidayName: 'Name, e.g. Christmas',
  add: 'Add',
  addSwissHolidays: 'Add common Swiss holidays {{year}}',
  swissHolidaysHint: 'Adds New Year, Berchtold’s Day, Good Friday, Easter Monday, Ascension, Whit Monday, 1 August, Christmas and St. Stephen’s Day. Cantonal holidays differ -- delete or add as needed.',
  showStats: 'Show statistics',
  allowanceUsed: '{{used}} of {{total}} days used or planned',
  perMonth: 'Days per month',
  entriesTitle: 'All entries',
  noEntries: 'No absences this year.',
  days: 'Days',
  statePast: 'past',
  stateNow: 'now',
  stateUpcoming: 'upcoming',
  halfDays: 'Half days only (each day counts ½)',
  addOvertime: 'Overtime / Note',
  kindAbsence: 'Absence',
  kindOvertime: 'Overtime / Note',
  newOvertime: 'New Overtime / Note',
  editOvertime: 'Edit Overtime / Note',
  date: 'Date',
  hours: 'Hours',
  hoursHint: 'Extra hours worked, e.g. 2 or 1.5. Negative (e.g. -3) = overtime taken off. Leave empty for just a note.',
  overtimeNotePlaceholder: 'e.g. stayed for the customer delivery',
  colOvertime: 'Overtime',
  overtimeHint: 'Overtime balance up to the end of the year (all entries so far)',
  overtimeThisYear: 'this year: {{hours}}',
  overtimeYear: 'Overtime this year',
  overtimeBalance: 'Overtime balance',
  overtimeTitle: 'Overtime & notes',
  noOvertime: 'No overtime or notes this year.',
  print: 'Print',
  reportTitle: 'Vacation & overtime {{year}}',
  reportRemaining: 'Still available (after planned days)',
};

const de = {
  title: 'Ferien',
  subtitle: 'Gemeinsamer Kalender für Ferien und Abwesenheiten -- wer weg ist und wie viele Tage alle noch haben',
  addAbsence: '+ Abwesenheit eintragen',
  editAbsence: 'Abwesenheit bearbeiten',
  newAbsence: 'Neue Abwesenheit',
  today: 'Heute',
  prevMonth: 'Vorheriger Monat',
  nextMonth: 'Nächster Monat',
  prevYear: 'Vorheriges Jahr',
  nextYear: 'Nächstes Jahr',
  viewMonth: 'Monat',
  viewYear: 'Jahr',
  awayToday: 'Heute abwesend',
  nobodyAway: 'Heute sind alle da',
  more: '+{{count}} weitere',
  type_vacation: 'Ferien',
  type_sick: 'Krank',
  type_other: 'Andere',
  halfDay: 'Halber Tag',
  person: 'Person',
  type: 'Art',
  from: 'Von',
  to: 'Bis',
  note: 'Notiz',
  notePlaceholder: 'optional',
  workingDays: 'Arbeitstage (Mo–Fr): {{count}}',
  save: 'Speichern',
  saving: 'Wird gespeichert...',
  delete: 'Löschen',
  confirmDelete: 'Diesen Eintrag löschen?',
  failedToLoad: 'Kalender konnte nicht geladen werden: {{error}}',
  failedToSave: 'Speichern fehlgeschlagen: {{error}}',
  readOnly: 'Nur {{name}} oder ein Admin kann diesen Eintrag ändern.',
  summaryTitle: 'Tage {{year}}',
  colName: 'Name',
  colAllowance: 'Anspruch',
  colTaken: 'Bezogen',
  colPlanned: 'Geplant',
  colRemaining: 'Verbleibend',
  colSick: 'Krank',
  colOther: 'Andere',
  allowanceHint: 'Klicken, um den Jahresanspruch zu ändern',
  countingNote: 'Gezählt werden Montag–Freitag, ohne die im Kalender eingetragenen Feiertage; halbe Tage zählen je ½. Nicht bezogene Tage werden ins nächste Jahr übertragen.',
  colCarryover: 'Übertrag',
  carryoverHint: 'Nicht bezogene Tage aus früheren Jahren (negativ = überzogen)',
  holidays: 'Feiertage',
  holiday: 'Feiertag',
  holidaysTitle: 'Feiertage {{year}}',
  noHolidays: 'Für dieses Jahr sind keine Feiertage eingetragen.',
  holidayName: 'Name, z. B. Weihnachten',
  add: 'Hinzufügen',
  addSwissHolidays: 'Übliche Schweizer Feiertage {{year}} eintragen',
  swissHolidaysHint: 'Trägt Neujahr, Berchtoldstag, Karfreitag, Ostermontag, Auffahrt, Pfingstmontag, 1. August, Weihnachten und Stephanstag ein. Kantonale Feiertage unterscheiden sich -- bei Bedarf löschen oder ergänzen.',
  showStats: 'Statistik anzeigen',
  allowanceUsed: '{{used}} von {{total}} Tagen bezogen oder geplant',
  perMonth: 'Tage pro Monat',
  entriesTitle: 'Alle Einträge',
  noEntries: 'Keine Abwesenheiten in diesem Jahr.',
  days: 'Tage',
  statePast: 'vorbei',
  stateNow: 'aktuell',
  stateUpcoming: 'geplant',
  halfDays: 'Nur halbe Tage (jeder Tag zählt ½)',
  addOvertime: 'Überstunden / Notiz',
  kindAbsence: 'Abwesenheit',
  kindOvertime: 'Überstunden / Notiz',
  newOvertime: 'Neue Überstunden / Notiz',
  editOvertime: 'Überstunden / Notiz bearbeiten',
  date: 'Datum',
  hours: 'Stunden',
  hoursHint: 'Zusätzlich gearbeitete Stunden, z. B. 2 oder 1.5. Negativ (z. B. -3) = Überstunden kompensiert. Leer lassen für nur eine Notiz.',
  overtimeNotePlaceholder: 'z. B. länger geblieben wegen Kundenlieferung',
  colOvertime: 'Überstunden',
  overtimeHint: 'Überstundensaldo bis Ende Jahr (alle bisherigen Einträge)',
  overtimeThisYear: 'dieses Jahr: {{hours}}',
  overtimeYear: 'Überstunden dieses Jahr',
  overtimeBalance: 'Überstundensaldo',
  overtimeTitle: 'Überstunden & Notizen',
  noOvertime: 'Keine Überstunden oder Notizen in diesem Jahr.',
  print: 'Drucken',
  reportTitle: 'Ferien & Überstunden {{year}}',
  reportRemaining: 'Noch verfügbar (nach geplanten Tagen)',
};

const vacations = { en, de };
export default vacations;
